import { useEffect, useRef } from 'react';

export const usePortal = (id) => {
  const rootElemRef = useRef(document.createElement('div'));

  useEffect(() => {
    document.querySelector(`#${id}`)?.appendChild(rootElemRef.current);

    return () => {
      rootElemRef.current.remove();
    };
  }, [id]);

  return rootElemRef.current;
};
